import React from 'react';
import i18next from 'i18next';
import { Redirect } from 'react-router-dom';
import { Modal, Tabs, Tab} from 'react-bootstrap';

import { DevicesService, DevicesRegistrationService } from '../../services';
import { PageTitle } from '../PageTitle';
import DeviceRegistrationForm from './registration_single_form';
import BulkRegistrationForm from './registration_bulk_form';

class DeviceRegistrationAdd extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showErrorModal: false,
            uploadErrors: [], 
            submitting: false
        }
    }

    componentDidMount() {
        DevicesService.getDeviceTypes().then(response => {
            this.setState({
                deviceTypeOptions: response.deviceTypes.map(deviceType => ({value: deviceType.id, label: `${deviceType.name} (${deviceType.deviceFunctionalType.name})`, deviceType: deviceType}))
            });
        }).catch((err) => {
            console.error(err);
        });
        DevicesService.getAvailableControllers().then(response => {
            this.setState({
                availableControllers: response.availableControllers.filter(ac => ac.deviceStatus.token === 'active')
            });
        }).catch((err) => {
            console.error(err);
        });
    }

    handleSingleSubmit(values) {
        this.setState({submitting: true});

        let deviceRegistrationRequest = {
            deviceType: values.deviceType.deviceType,
            name: values.name,
            description: values.description,
            hardwareSerialNumber: values.hardwareSerialNumber
        }

        if (values.controllerCommunicationType && values.controllerOpSenseSerialNumber) {
            deviceRegistrationRequest.controllerOpSenseSerialNumber = values.controllerOpSenseSerialNumber.controller.serialNumber;

            if (values.controllerCommunicationType.controllerCommunicationType == 'mb_rtu') {
                var subDeviceAddress = "mb_rtu:" + values.modbusRTUUnitId;

                if (values.modbusRTUTimeout) {
                    subDeviceAddress = subDeviceAddress + ":" + values.modbusRTUTimeout;
                }
                if (values.modbusRTUSerialConfig) {
                    subDeviceAddress = subDeviceAddress + ":" + values.modbusRTUSerialConfig;
                }

                deviceRegistrationRequest.subDeviceAddress = subDeviceAddress;
            } else if (values.controllerCommunicationType.controllerCommunicationType == 'mb_tcp') {
                var subDeviceAddress = "mb_tcp:" + values.modbusTCPIP + ":" + values.modbusTCPPort;

                if (values.modbusTCPTimeout) {
                    subDeviceAddress = subDeviceAddress + ":" + values.modbusTCPTimeout;
                }

                deviceRegistrationRequest.subDeviceAddress = subDeviceAddress;
            }
        }
        
        DevicesRegistrationService.registerDevice(deviceRegistrationRequest).then(({response}) => {
            if (response.errorMessage) {
                this.setState({
                    errorMessage: response.errorMessage
                });
            } else {
                this.setState({
                    successMessage: i18next.t("messages.device-successfully-registered"),
                    deviceId: response.deviceDTO && response.deviceDTO.id,
                });
            }
        }).catch((err) => {
            let errorMessage = i18next.t('messages.device-registration-failed');
            if (err.response && err.response.data && err.response.data.errorMessage && err.response.data.errorMessage !== '') {
                errorMessage = `${errorMessage}: ${err.response.data.errorMessage}`;
            }
            this.setState({
                errorMessage: errorMessage
            });
        });
    }

    handleBulkSubmit({deviceType, csvFile}) {
        this.setState({submitting: true});

        DevicesRegistrationService.bulkRegisterDevices(deviceType.deviceType, csvFile).then(response => {
            if (response.length === 0) {
                this.setState({successMessage: 'All devices successfully registered'})
            } else {
                this.setState({showErrorModal: true, uploadErrors: response, submitting: false});
            }
        }).catch(err => {
            console.error(err);
            this.setState({
                errorMessage: i18next.t('messages.device-registration-failed')
            });
        })
    }

    render() {
        if (this.state.successMessage) {
            if (this.state.deviceId) {
                return (
                    <Redirect to={{
                    pathname: `/config/devices/view/${this.state.deviceId}`,
                    state: {
                        successMessage: this.state.successMessage
                    }
                    }}/>
                );
            } else {
                return (
                    <Redirect to={{
                    pathname: '/config/registrations',
                    state: {
                        successMessage: this.state.successMessage
                    }
                    }}/>
                );
            }
        } 

        if (this.state.errorMessage) {
            return (
                <Redirect to={{
                  pathname: '/config/registrations',
                  state: {
                    errorMessage: this.state.errorMessage
                  }
                }}/>
            );
        }

        if (this.state.deviceTypeOptions && this.state.availableControllers && !this.state.submitting) {
            const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
            return (<div>
                <PageTitle 
                    title={i18next.t('pages.device-registrations.register-device')}
                    backLinkWithParams={{
                        link: {
                          pathname: "/config/registrations",
                          search: backLinkSearch
                        }
                      }}
                />
                <div className="row">
                    <div className="op-content-box">
                        <Tabs id="registration-tabs" defaultActiveKey="single" mountOnEnter={true}>
                            <Tab eventKey="single" title="Single">
                                <DeviceRegistrationForm
                                    onSubmit={this.handleSingleSubmit.bind(this)}
                                    deviceTypeOptions={this.state.deviceTypeOptions}
                                    availableControllers={this.state.availableControllers}
                                    backLinkWithParams={{
                                        link: {
                                        pathname: "/config/registrations",
                                        search: backLinkSearch
                                        }
                                    }}
                                /> 
                            </Tab>
                            <Tab eventKey="bulk" title="Bulk">
                                <BulkRegistrationForm
                                    onSubmit={this.handleBulkSubmit.bind(this)}
                                    deviceTypeOptions={this.state.deviceTypeOptions}
                                    backLinkWithParams={{
                                        link: {
                                        pathname: "/config/registrations",
                                        search: backLinkSearch
                                        }
                                    }}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
                <Modal bsSize='large' show = {this.state.showErrorModal} onHide = {() => this.setState({showErrorModal: false})}>
                    <Modal.Header className='modal-warning' closeButton>
                        <Modal.Title>{i18next.t('error')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Not all records could be processed. Correct and resubmit for the following errors:
                        <ul>
                        {this.state.uploadErrors.map(error => {
                            return <li>{error.errorMessage}</li>
                        })}
                        </ul>
                    </Modal.Body>
                </Modal>
            </div>);
        } else {
            return (
                <div className="loader">{i18next.t('loading')}</div>
            );
        }
    }
}

export default DeviceRegistrationAdd;